import React from "react";

interface ToastProps {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: ToastProps) {
  return (
    <div
      className={`pointer-events-none fixed left-1/2 z-[999] max-w-[calc(100vw-2rem)] -translate-x-1/2 rounded-full border border-[hsl(var(--border))] bg-[hsl(var(--bg2))] px-5 py-2.5 text-center text-[13px] font-medium text-[hsl(var(--foreground))] whitespace-nowrap transition-opacity md:bottom-6 bottom-[calc(5rem+env(safe-area-inset-bottom))] ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      {message}
    </div>
  );
}
